module.exports = __webpack_public_path__ + "static/img/title.0f5b1c2a.png";